var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        (function () {
            document.addEventListener('DOMContentLoaded', function () {
                var page = document.querySelector('[data-complaints-page]');

                if (!page) {
                    return;
                }

                var SmsCodeInput = function () {
                    function SmsCodeInput(wrapper) {
                        _classCallCheck(this, SmsCodeInput);

                        this.wrapper = wrapper;
                        this.inputs = Array.prototype.slice.call(wrapper.querySelectorAll('[data-sms-code-input]'));
                        this.hiddenInput = wrapper.querySelector('[data-sms-code-value]');
                    }

                    _createClass(SmsCodeInput, [{
                        key: "init",
                        value: function init() {
                            var _this = this;

                            if (!this.inputs.length) {
                                return;
                            }

                            this.inputs.forEach(function (input, index) {
                                return _this.bindInput(input, index);
                            });
                            this.updateValue();
                        }
                    }, {
                        key: "bindInput",
                        value: function bindInput(input, index) {
                            var _this2 = this;

                            input.addEventListener('focus', function () {
                                input.select();
                            });

                            input.addEventListener('keydown', function (event) {
                                return _this2.handleKeydown(event, input, index);
                            });
                            input.addEventListener('input', function () {
                                return _this2.handleInput(input, index);
                            });
                            input.addEventListener('paste', function (event) {
                                return _this2.handlePaste(event, index);
                            });
                        }
                    }, {
                        key: "handleKeydown",
                        value: function handleKeydown(event, input, index) {
                            if (event.ctrlKey || event.metaKey || event.altKey) {
                                return;
                            }

                            if (/^\d$/.test(event.key)) {
                                event.preventDefault();
                                input.value = event.key;
                                this.updateValue();
                                this.focusByIndex(index + 1);
                                return;
                            }

                            if (event.key === 'Backspace') {
                                event.preventDefault();
                                this.handleBackspace(input, index);
                                return;
                            }

                            if (event.key === 'Delete') {
                                event.preventDefault();
                                input.value = '';
                                this.updateValue();
                                return;
                            }

                            if (event.key === 'ArrowLeft') {
                                event.preventDefault();
                                this.focusByIndex(index - 1);
                                return;
                            }

                            if (event.key === 'ArrowRight') {
                                event.preventDefault();
                                this.focusByIndex(index + 1);
                            }
                        }
                    }, {
                        key: "handleBackspace",
                        value: function handleBackspace(input, index) {
                            if (input.value) {
                                input.value = '';
                                this.updateValue();
                                this.focusByIndex(index - 1);
                                return;
                            }

                            var previousInput = this.inputs[index - 1];

                            if (previousInput) {
                                previousInput.value = '';
                                this.updateValue();
                                this.focusInput(previousInput);
                            }
                        }
                    }, {
                        key: "handleInput",
                        value: function handleInput(input, index) {
                            var digits = this.getDigits(input.value);

                            input.value = '';

                            if (!digits.length) {
                                this.updateValue();
                                return;
                            }

                            this.fillFromIndex(index, digits);
                        }
                    }, {
                        key: "handlePaste",
                        value: function handlePaste(event, index) {
                            var clipboardText = event.clipboardData ? event.clipboardData.getData('text') : '';
                            var digits = this.getDigits(clipboardText);

                            if (!digits.length) {
                                return;
                            }

                            event.preventDefault();
                            this.fillFromIndex(index, digits);
                        }
                    }, {
                        key: "fillFromIndex",
                        value: function fillFromIndex(startIndex, digits) {
                            var _this3 = this;

                            digits.forEach(function (digit, digitIndex) {
                                var input = _this3.inputs[startIndex + digitIndex];

                                if (input) {
                                    input.value = digit;
                                }
                            });

                            this.updateValue();
                            this.focusByIndex(Math.min(startIndex + digits.length, this.inputs.length - 1));
                        }
                    }, {
                        key: "updateValue",
                        value: function updateValue() {
                            if (!this.hiddenInput) {
                                return;
                            }

                            this.hiddenInput.value = this.inputs.map(function (input) {
                                return input.value;
                            }).join('');
                            this.wrapper.dispatchEvent(new CustomEvent('smsCodeChanged', {
                                bubbles: true,
                                detail: {
                                    value: this.hiddenInput.value
                                }
                            }));
                        }
                    }, {
                        key: "getDigits",
                        value: function getDigits(value) {
                            return String(value || '').replace(/\D/g, '').split('');
                        }
                    }, {
                        key: "focusByIndex",
                        value: function focusByIndex(index) {
                            var input = this.inputs[index];

                            if (input) {
                                this.focusInput(input);
                            }
                        }
                    }, {
                        key: "focusInput",
                        value: function focusInput(input) {
                            input.focus();
                            input.select();
                        }
                    }]);

                    return SmsCodeInput;
                }();

                var formWrapper = page.querySelector('[data-complaints-form-wrapper]');
                var form = page.querySelector('[data-complaints-form]');
                var submitButton = page.querySelector('[data-complaints-submit]');
                var smsBlock = page.querySelector('[data-complaints-sms]');
                var smsVerification = page.querySelector('[data-complaints-sms-verification]');
                var smsCodeWrapper = page.querySelector('[data-sms-code]');
                var smsActions = page.querySelector('[data-complaints-sms-actions]');
                var smsPendingButton = page.querySelector('[data-complaints-sms-pending]');
                var smsError = page.querySelector('[data-complaints-sms-error]');
                var successBlock = page.querySelector('[data-complaints-success]');
                var successNumber = page.querySelector('[data-complaints-success-number]');
                var smsPhone = page.querySelector('[data-complaints-sms-phone]');
                var resendButton = page.querySelector('[data-complaints-sms-resend]');
                var smsCooldownMessage = page.querySelector('[data-complaints-sms-cooldown-message]');
                var changePhoneButton = page.querySelector('[data-complaints-change-phone]');
                var emptyTopicSelect = page.querySelector('[data-complaints-topic-empty]');
                var topicSelects = Array.prototype.slice.call(page.querySelectorAll('[data-complaints-topic-category]'));
                var fallbackErrorMessage = page.dataset.complaintsErrorMessage || '';
                var errorTitle = page.dataset.complaintsErrorTitle || '';
                var errorRetryLabel = page.dataset.complaintsErrorRetryLabel || '';
                var errorCloseLabel = page.dataset.complaintsErrorCloseLabel || '';
                var resendTimerId = 0;
                var resendSecondsLeft = 0;
                var lastSubmittedSignature = '';
                var lastSubmittedPhone = '';
                var isResendAvailable = false;
                var isSmsSubmitting = false;

                function getWidgetValue(widgetId) {
                    var widget = page.querySelector('.ui-select[data-widget-id="' + widgetId + '"]');
                    var valueInput = widget ? widget.querySelector('.ui-select__toggle-value') : null;

                    return valueInput ? valueInput.value : '';
                }

                function syncHiddenField(widgetId, value) {
                    var field = page.querySelector('[data-complaints-field="' + widgetId + '"]');

                    if (field) {
                        field.value = value;
                    }
                }

                function resetUiSelect(selectWrapper) {
                    var toggle = selectWrapper ? selectWrapper.querySelector('.ui-select__toggle') : null;
                    var content = toggle ? document.getElementById(toggle.dataset.contentId || '') : null;
                    var toggleValue = toggle ? toggle.querySelector('.ui-select__toggle-value') : null;
                    var toggleLabel = toggle ? toggle.querySelector('.ui-select__toggle-label') : null;
                    var resetButton = toggle ? toggle.querySelector('.ui-select__reset') : null;

                    if (!toggle) {
                        return;
                    }

                    if (toggleValue) {
                        toggleValue.value = '';
                    }

                    if (toggleLabel) {
                        toggleLabel.textContent = toggle.dataset.defaultLabel || '';
                        toggleLabel.classList.remove('changed');
                    }

                    if (resetButton) {
                        resetButton.classList.add('hidden');
                    }

                    if (content) {
                        content.querySelectorAll('.ui-select__option-value').forEach(function (input) {
                            input.checked = false;
                        });
                    }
                }

                function getTopicSelectByCategory(categoryValue) {
                    var i;

                    for (i = 0; i < topicSelects.length; i += 1) {
                        if (String(topicSelects[i].dataset.complaintsTopicCategory) === String(categoryValue)) {
                            return topicSelects[i];
                        }
                    }

                    return null;
                }

                function updateTopicSelect(categoryValue) {
                    var activeTopicSelect = getTopicSelectByCategory(categoryValue);

                    topicSelects.forEach(function (selectWrapper) {
                        resetUiSelect(selectWrapper);
                        selectWrapper.classList.add('complaints-topic-select_hidden');
                    });

                    syncHiddenField('complaints-topic', '');

                    if (emptyTopicSelect) {
                        emptyTopicSelect.classList.toggle('complaints-topic-select_hidden', !!activeTopicSelect);
                    }

                    if (activeTopicSelect) {
                        activeTopicSelect.classList.remove('complaints-topic-select_hidden');
                    }
                }

                function getFirstErrorMessage(messages) {
                    return Array.isArray(messages) ? messages[0] : messages;
                }

                function getFieldContainer(fieldName) {
                    var field = form ? form.querySelector('[name="' + fieldName + '"]') : null;

                    if (fieldName === 'phone' || fieldName === 'phoneCode') {
                        return form ? form.querySelector('[data-ui-phone-number]') : null;
                    }

                    if (fieldName === 'message') {
                        return field ? field.closest('.complaints-message') : null;
                    }

                    if (fieldName === 'attachments') {
                        return form ? form.querySelector('[data-ui-file-upload]') : null;
                    }

                    return field ? field.closest('.complaints-field') : null;
                }

                function clearFieldError(container) {
                    var error;

                    if (!container) {
                        return;
                    }

                    container.classList.remove('complaints-field_error');
                    container.classList.remove('complaints-message_error');
                    container.classList.remove('complaints-file-upload_error');

                    error = container.querySelector('[data-complaints-error-text]');

                    if (error) {
                        error.remove();
                    }

                    if (container.matches('[data-ui-phone-number]')) {
                        container.dispatchEvent(new CustomEvent('ui-phone-number:clear-error', {
                            bubbles: true
                        }));
                    }

                    if (container.matches('[data-ui-file-upload]')) {
                        error = container.querySelector('[data-ui-file-upload-error]');

                        if (error) {
                            error.textContent = '';
                            error.classList.remove('ui-file-upload__error_visible');
                        }
                    }
                }

                function clearErrors() {
                    if (!form) {
                        return;
                    }

                    form.querySelectorAll('.complaints-field_error, .complaints-message_error, .complaints-file-upload_error, [data-ui-phone-number]').forEach(function (container) {
                        clearFieldError(container);
                    });
                }

                function showCommonFieldError(container, message) {
                    var error = document.createElement('div');

                    error.className = 'complaints-error-text';
                    error.dataset.complaintsErrorText = '1';
                    error.textContent = message;

                    container.appendChild(error);
                }

                function showFieldError(fieldName, message) {
                    var container = getFieldContainer(fieldName);
                    var fileError;

                    if (!container) {
                        return;
                    }

                    clearFieldError(container);

                    if (container.matches('[data-ui-phone-number]')) {
                        container.dispatchEvent(new CustomEvent('ui-phone-number:set-error', {
                            bubbles: true,
                            detail: {
                                message: message
                            }
                        }));
                        return;
                    }

                    if (container.matches('[data-ui-file-upload]')) {
                        container.classList.add('complaints-file-upload_error');
                        fileError = container.querySelector('[data-ui-file-upload-error]');

                        if (fileError) {
                            fileError.textContent = message;
                            fileError.classList.add('ui-file-upload__error_visible');
                        }
                        return;
                    }

                    if (container.classList.contains('complaints-message')) {
                        container.classList.add('complaints-message_error');
                    } else {
                        container.classList.add('complaints-field_error');
                    }

                    showCommonFieldError(container, message);
                }

                function showValidationErrors(errors) {
                    Object.keys(errors || {}).forEach(function (fieldName) {
                        showFieldError(fieldName, getFirstErrorMessage(errors[fieldName]));
                    });
                }

                function setSubmitting(isSubmitting) {
                    if (!submitButton) {
                        return;
                    }

                    submitButton.disabled = isSubmitting || formWrapper && formWrapper.classList.contains('complaints-form-wrapper_locked');
                }

                function showPageLoader() {
                    if (typeof window.showPageLoader === 'function') {
                        window.showPageLoader();
                        return;
                    }

                    if (document.querySelector('.page-loader')) {
                        return;
                    }

                    document.body.classList.add('disable-interaction');
                    var loader = document.createElement('div');

                    loader.className = 'page-loader';
                    loader.innerHTML = '<div class="circle-loader"><svg viewBox="25 25 50 50"><circle cx="50" cy="50" r="20"></circle></svg></div>';
                    document.body.appendChild(loader);
                }

                function hidePageLoader() {
                    var loader;

                    if (typeof window.hidePageLoader === 'function') {
                        window.hidePageLoader();
                        return;
                    }

                    document.body.classList.remove('disable-interaction');
                    loader = document.querySelector('.page-loader');

                    if (loader) {
                        loader.remove();
                    }
                }

                function escapeHtml(value) {
                    var node = document.createElement('div');

                    node.textContent = value || '';

                    return node.innerHTML;
                }

                function showErrorModal(message) {
                    var type;

                    if (!window.modal || typeof window.modal.open !== 'function') {
                        return;
                    }

                    type = window.innerWidth >= 768 ? window.modal.types.FLOATING : window.modal.types.BOTTOM;
                    window.modal.open({
                        id: 'complaints-error-modal',
                        type: type,
                        parentCssClass: 'complaints-error-modal',
                        header: {
                            title: escapeHtml(errorTitle)
                        },
                        content: {
                            html: '<div class="complaints-error-modal__message">' + escapeHtml(message || fallbackErrorMessage) + '</div>' + '<button type="button" class="btn btn-blue complaints-error-modal__retry modal2-close">' + escapeHtml(errorRetryLabel) + '</button>' + '<button type="button" class="complaints-error-modal__close modal2-close">' + escapeHtml(errorCloseLabel) + '</button>'
                        }
                    });
                }

                function getFormSignature() {
                    var formData = new FormData(form);
                    var values = [];

                    formData.forEach(function (value, key) {
                        if (key.indexOf('_csrf') !== -1 || key === 'smsCode') {
                            return;
                        }

                        if (value instanceof File) {
                            if (!value.name && value.size === 0) {
                                return;
                            }

                            values.push(key + '=' + value.name + ':' + value.size + ':' + value.lastModified);
                            return;
                        }

                        values.push(key + '=' + value);
                    });

                    return values.sort().join('&');
                }

                function collectFormData() {
                    var disabledFields = Array.prototype.slice.call(form.querySelectorAll(':disabled'));
                    var formData;

                    disabledFields.forEach(function (field) {
                        field.disabled = false;
                    });

                    formData = new FormData(form);
                    syncFileUploadFormData(formData);

                    disabledFields.forEach(function (field) {
                        field.disabled = true;
                    });

                    return formData;
                }

                function syncFileUploadFormData(formData) {
                    form.querySelectorAll('[data-ui-file-upload]').forEach(function (upload) {
                        var input = upload.querySelector('[data-ui-file-upload-input]');
                        var inputName = input ? input.name : '';
                        var widgetFiles = upload.uiFileUploadWidget ? upload.uiFileUploadWidget.files : [];

                        if (!inputName) {
                            return;
                        }

                        formData.delete(inputName);

                        Array.prototype.slice.call(widgetFiles || []).forEach(function (file) {
                            if (file && file.name) {
                                formData.append(inputName, file);
                            }
                        });
                    });
                }

                function getDisplayedPhone() {
                    var code = form ? form.querySelector('[name="phoneCode"]') : null;
                    var phone = form ? form.querySelector('[name="phone"]') : null;
                    var codeValue = code ? code.value : '';
                    var phoneValue = phone ? phone.value : '';

                    return '+' + codeValue + ' ' + phoneValue;
                }

                function setFormLocked(isLocked) {
                    if (!form || !formWrapper) {
                        return;
                    }

                    formWrapper.classList.toggle('complaints-form-wrapper_locked', isLocked);
                    form.querySelectorAll('input, textarea, button, select').forEach(function (field) {
                        field.disabled = isLocked;
                    });

                    if (submitButton) {
                        submitButton.classList.toggle('complaints-submit_hidden', isLocked);
                        submitButton.disabled = isLocked;
                    }
                }

                function showSmsBlock(shouldRestartTimer, phone) {
                    if (!smsBlock) {
                        return;
                    }

                    resetSmsCodeInputs();
                    showSmsVerificationState();

                    if (smsPhone) {
                        smsPhone.textContent = phone || getDisplayedPhone();
                    }

                    smsBlock.classList.remove('complaints-sms_hidden');
                    setFormLocked(true);

                    if (shouldRestartTimer) {
                        hideSmsCooldownMessage();
                        startResendTimer(60);
                    } else {
                        updateResendButton();
                    }
                }

                function hideSmsBlock() {
                    if (smsBlock) {
                        smsBlock.classList.add('complaints-sms_hidden');
                    }

                    hideSmsCooldownMessage();
                    setFormLocked(false);
                }

                function resetSmsCodeInputs() {
                    if (!smsCodeWrapper) {
                        return;
                    }

                    smsCodeWrapper.querySelectorAll('[data-sms-code-input]').forEach(function (input) {
                        input.value = '';
                    });

                    var hiddenInput = smsCodeWrapper.querySelector('[data-sms-code-value]');

                    if (hiddenInput) {
                        hiddenInput.value = '';
                    }
                }

                function showSmsVerificationState() {
                    if (formWrapper) {
                        formWrapper.classList.remove('complaints-form-wrapper_hidden');
                    }

                    if (smsVerification) {
                        smsVerification.classList.remove('complaints-sms-verification_hidden');
                    }

                    if (successBlock) {
                        successBlock.classList.add('complaints-success_hidden');
                    }

                    setSmsSubmitting(false);
                    clearSmsError();
                }

                function showSuccessState(complaintNumber) {
                    window.clearInterval(resendTimerId);

                    if (formWrapper) {
                        formWrapper.classList.add('complaints-form-wrapper_hidden');
                    }

                    if (smsBlock) {
                        smsBlock.classList.add('complaints-sms_hidden');
                    }

                    if (successNumber && complaintNumber) {
                        successNumber.textContent = complaintNumber;
                    }

                    if (successBlock) {
                        successBlock.classList.remove('complaints-success_hidden');
                    }

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                }

                function setSmsSubmitting(isSubmitting) {
                    isSmsSubmitting = isSubmitting;

                    if (smsActions) {
                        smsActions.classList.toggle('complaints-sms__actions_hidden', isSubmitting);
                    }

                    if (smsPendingButton) {
                        smsPendingButton.classList.toggle('complaints-sms__pending_hidden', !isSubmitting);
                    }
                }

                function showSmsError(message) {
                    if (!smsError) {
                        return;
                    }

                    smsError.textContent = message || smsError.textContent;
                    smsError.classList.remove('complaints-sms-code-error_hidden');

                    if (smsCodeWrapper) {
                        smsCodeWrapper.classList.add('complaints-sms-code-wrapper_error');
                    }
                }

                function clearSmsError() {
                    if (!smsError) {
                        return;
                    }

                    smsError.classList.add('complaints-sms-code-error_hidden');

                    if (smsCodeWrapper) {
                        smsCodeWrapper.classList.remove('complaints-sms-code-wrapper_error');
                    }
                }

                function updateSmsCooldownMessage() {
                    var label;

                    if (!smsCooldownMessage || smsCooldownMessage.classList.contains('complaints-sms__cooldown-message_hidden')) {
                        return;
                    }

                    label = smsCooldownMessage.dataset.label || '';
                    smsCooldownMessage.textContent = label.replace('{seconds}', resendSecondsLeft);
                }

                function showSmsCooldownMessage() {
                    if (!smsCooldownMessage) {
                        return;
                    }

                    smsCooldownMessage.classList.remove('complaints-sms__cooldown-message_hidden');
                    updateSmsCooldownMessage();
                }

                function hideSmsCooldownMessage() {
                    if (!smsCooldownMessage) {
                        return;
                    }

                    smsCooldownMessage.classList.add('complaints-sms__cooldown-message_hidden');
                }

                function updateResendButton() {
                    var label;

                    if (!resendButton) {
                        return;
                    }

                    updateSmsCooldownMessage();

                    if (resendSecondsLeft > 0) {
                        label = resendButton.dataset.countdownLabel || '';
                        resendButton.textContent = label.replace('{seconds}', resendSecondsLeft);
                        resendButton.disabled = true;
                        return;
                    }

                    resendButton.textContent = resendButton.dataset.label || resendButton.textContent;
                    resendButton.disabled = false;
                }

                function startResendTimer(seconds) {
                    window.clearInterval(resendTimerId);
                    resendSecondsLeft = seconds;
                    isResendAvailable = false;
                    updateResendButton();

                    resendTimerId = window.setInterval(function () {
                        resendSecondsLeft -= 1;

                        if (resendSecondsLeft <= 0) {
                            window.clearInterval(resendTimerId);
                            resendSecondsLeft = 0;
                            isResendAvailable = true;
                            hideSmsCooldownMessage();
                        }

                        updateResendButton();
                    }, 1000);
                }

                function handleSuccessfulSubmit(signature, phone) {
                    hidePageLoader();
                    lastSubmittedSignature = signature;
                    lastSubmittedPhone = phone || getDisplayedPhone();
                    showSmsBlock(true, lastSubmittedPhone);
                }

                function handleSubmit(event) {
                    var formData;
                    var signature;

                    event.preventDefault();

                    if (!form) {
                        return;
                    }

                    signature = getFormSignature();

                    if (lastSubmittedSignature && !isResendAvailable) {
                        clearErrors();
                        showSmsBlock(false, lastSubmittedPhone);
                        showSmsCooldownMessage();
                        return;
                    }

                    clearErrors();
                    setSubmitting(true);
                    showPageLoader();
                    formData = collectFormData();

                    fetch(form.action, {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }).then(function (response) {
                        return response.json();
                    }).then(function (response) {
                        if (response.success && response.step === 'created') {
                            hidePageLoader();
                            showSuccessState(response.complaintNumber || '');
                            return;
                        }

                        if (response.success) {
                            handleSuccessfulSubmit(signature, response.phone || '');
                            return;
                        }

                        hidePageLoader();

                        if (response.errors) {
                            showValidationErrors(response.errors);
                            return;
                        }

                        showErrorModal(response.message || fallbackErrorMessage);
                    }).catch(function () {
                        hidePageLoader();
                        showErrorModal(fallbackErrorMessage);
                    }).finally(function () {
                        setSubmitting(false);
                    });
                }

                function handleResendClick() {
                    if (!isResendAvailable || !form) {
                        return;
                    }

                    setFormLocked(false);
                    form.dispatchEvent(new Event('submit', {
                        bubbles: true,
                        cancelable: true
                    }));
                }

                function handleChangePhoneClick() {
                    hideSmsBlock();
                }

                function submitSmsCode(value) {
                    var formData;

                    if (isSmsSubmitting || String(value || '').length < 6) {
                        return;
                    }

                    clearSmsError();
                    setSmsSubmitting(true);
                    formData = collectFormData();
                    formData.set('smsCode', value);

                    fetch(form.action, {
                        method: 'POST',
                        body: formData,
                        credentials: 'same-origin',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest'
                        }
                    }).then(function (response) {
                        return response.json();
                    }).then(function (response) {
                        if (response.success && response.step === 'created') {
                            showSuccessState(response.complaintNumber || '');
                            return;
                        }

                        if (response.errorType === 'smsCode') {
                            showSmsError(response.message || '');
                            return;
                        }

                        if (response.errors) {
                            hideSmsBlock();
                            showValidationErrors(response.errors);
                            return;
                        }

                        showErrorModal(response.message || fallbackErrorMessage);
                    }).catch(function () {
                        showErrorModal(fallbackErrorMessage);
                    }).finally(function () {
                        setSmsSubmitting(false);
                    });
                }

                page.querySelectorAll('[data-complaints-ui-select]').forEach(function (selectWrapper) {
                    var widgetId = selectWrapper.dataset.complaintsUiSelect;

                    syncHiddenField(widgetId, getWidgetValue(widgetId));
                });

                page.querySelectorAll('[data-sms-code]').forEach(function (wrapper) {
                    new SmsCodeInput(wrapper).init();
                });

                page.addEventListener('smsCodeChanged', function (event) {
                    clearSmsError();
                    submitSmsCode(event.detail ? event.detail.value : '');
                });

                updateTopicSelect(getWidgetValue('complaints-category'));

                page.addEventListener('ui-select:change', function (event) {
                    var widgetId = event.detail && event.detail.widgetId ? event.detail.widgetId : '';

                    if (!widgetId) {
                        return;
                    }

                    if (widgetId === 'complaints-category') {
                        syncHiddenField(widgetId, event.detail.value || '');
                        updateTopicSelect(event.detail.value || '');
                        clearFieldError(getFieldContainer('topic'));

                        return;
                    }

                    if (widgetId.indexOf('complaints-topic-') === 0) {
                        syncHiddenField('complaints-topic', event.detail.value || '');

                        return;
                    }

                    syncHiddenField(widgetId, event.detail.value || '');
                });

                page.addEventListener('input', function (event) {
                    var field = event.target.closest('[name]');

                    if (field) {
                        clearFieldError(getFieldContainer(field.name));
                    }
                });

                page.addEventListener('ui-select:change', function (event) {
                    var widgetId = event.detail && event.detail.widgetId ? event.detail.widgetId : '';
                    var fieldName = '';

                    if (widgetId === 'complaints-category') {
                        fieldName = 'category';
                    } else if (widgetId.indexOf('complaints-topic-') === 0) {
                        fieldName = 'topic';
                    } else if (widgetId === 'complaints-city') {
                        fieldName = 'city';
                    }

                    if (!fieldName && event.target.closest('[data-ui-phone-number]')) {
                        fieldName = 'phone';
                    }

                    if (!fieldName) {
                        return;
                    }

                    clearFieldError(getFieldContainer(fieldName));
                });

                if (form) {
                    form.addEventListener('submit', handleSubmit);
                }

                if (resendButton) {
                    resendButton.addEventListener('click', handleResendClick);
                }

                if (changePhoneButton) {
                    changePhoneButton.addEventListener('click', handleChangePhoneClick);
                }
            });
        })();
    }, {}] }, {}, [1]);